import React from 'react';
import {Button} from "primereact/button";
import config from "../../config";
import * as Icons from '../../icons';
import {dateToPersian, ticketSeverity} from "../../utils/functions";
import {useNavigate} from "react-router-dom";
function IncidentItem({data}) {
    const navigate = useNavigate();
    return (
        <div className="flex flex-column gap-2 pt-4 pb-4">
            <div className="flex justify-content-end">
                {
                    data._kph_lastresponder_value!==data._ownerid_value && (
                        <Button className="flex gap-2 align-items-center p-button-raised text-xs p-button-sm border-none p-2 pr-3 pl-3" style={{backgroundImage: 'linear-gradient(74deg, #005687 3%, #7cabc6 99%, #003c5f 99%)'}}>
                            <Icons.Support/>
                            <span>{config.glossary.supportAnswer}</span>
                        </Button>
                    )
                }
            </div>
            <div className="bg-white border-round-2xl shadow-2 w-full">
                {/*header*/}
                <div className="flex text-sm w-full justify-content-between border-bottom-1 border-gray-300 align-items-center cursor-pointer" onClick={()=>{navigate(`/case/note/${data.incidentid}`)}}>
                    <div className="flex flex-column flex-1 gap-2 pr-2 p-2 ">
                        <span className="overflow-hidden">{data.title}</span>
                        <span className="text-gray-500 text-xs">شماره تیکت: <span className="english-font">{data.ticketnumber}#</span></span>
                    </div>
                    <span className={`${ticketSeverity(data.statecode)} h-full pl-2 h-4rem flex align-items-center`}><span className="bg-white p-2 pr-4 pl-4 border-round-2xl text-xs">{data["statecode@OData.Community.Display.V1.FormattedValue"]}</span></span>
                </div>
                {/*content*/}
                <div className="w-full p-2">
                    <span className="text-sm line-height-4 text-gray-700 w-full">{data.description}</span>
                </div>
                {/*footer*/}
                <div className="flex justify-content-end text-xs text-gray-500 w-full p-3 pb-2 gap-4">
                    <div className="w-4 lg:w-fit flex flex-column lg:flex-row">
                        <span className="white-space-nowrap text-overflow-ellipsis overflow-hidden">زمان ایجاد:</span>
                        <span>{dateToPersian(new Date(data.createdon), "hh:mm-YYYY/MM/DD")}</span>
                    </div>
                    <div className="w-4 lg:w-fit flex flex-column lg:flex-row">
                        <span className="white-space-nowrap text-overflow-ellipsis overflow-hidden">آخرین بروزرسانی:</span>
                        <span>{dateToPersian(new Date(data.modifiedon), "hh:mm-YYYY/MM/DD")}</span>
                    </div>
                    <div className="w-4 lg:w-fit flex flex-column lg:flex-row">
                        <span className="white-space-nowrap text-overflow-ellipsis overflow-hidden">ثبت کننده:</span>
                        <span>{data['_primarycontactid_value@OData.Community.Display.V1.FormattedValue']?data['_primarycontactid_value@OData.Community.Display.V1.FormattedValue']:data['_customerid_value@OData.Community.Display.V1.FormattedValue']}</span>
                    </div>


                </div>
            </div>
        </div>
    );
}

export default IncidentItem;